module.exports = "<!--<a class=\"drop-menu-option-link\" (click)=\"openGuidenceModal($event)\">Interactive</a>-->\n<a class=\"drop-menu-option-link\" (click)=\"navigate($event, 'app.authorized.about')\">About</a>\n<a class=\"drop-menu-option-link\" (click)=\"onlineDocLink()\">Online</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/side-menu/about-menu-drop-down/about-menu-drop-down.component.html
// module id = 1834
// module chunks = 0